import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { Pin } from "lucide-react";

export default function RecommendationStrip({ context = "product", productId, occasion, title = "Recommended for you", testid = "recs" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const q = new URLSearchParams({ context, limit: "8" });
    if (productId) q.set("product_id", productId);
    if (occasion) q.set("occasion", occasion);
    api.get(`/recommendations?${q.toString()}`).then(({ data }) => setItems(data.items)).catch(() => {});
  }, [context, productId, occasion]);
  if (!items.length) return null;
  return (
    <section className="mt-14" data-testid={testid}>
      <div className="sq-eyebrow text-squire-jeans">{context === "cart" ? "Complete the look" : context === "wardrobe" ? "Wardrobe matches" : "For you"}</div>
      <h3 className="font-display text-3xl mt-2 mb-6">{title}</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        {items.map((p) => (
          <Link key={p.id} to={`/product/${p.id}`} data-testid={`${testid}-${p.id}`} className="group block">
            <div className="aspect-[3/4] overflow-hidden bg-[#F5F5F5] relative">
              <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              {p._pinned && <span className="absolute top-2 left-2 bg-squire-jeans text-white text-[10px] uppercase tracking-[0.2em] px-2 py-1 flex items-center gap-1"><Pin size={10} /> Pinned</span>}
            </div>
            <div className="mt-3 flex items-start justify-between gap-2">
              <div className="font-display text-sm leading-tight">{p.name}</div>
              <div className="text-sm font-semibold whitespace-nowrap">{formatINR(p.price)}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
